import { render, staticRenderFns } from "./ListUserTable.vue?vue&type=template&id=2774e134&scoped=true"
import script from "./ListUserTable.vue?vue&type=script&lang=ts"
export * from "./ListUserTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2774e134",
  null
  
)

export default component.exports